import React, {FC, memo, useEffect} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions as actionApp} from "../../store/sliceApp";
import {PageMainArticle, PageMainContainer, PageMainText} from "./PageMainStyle";
import cameraIcon from "../../image/camera.png"
import fileIcon from "../../image/files.png"
import homeIcon from "../../image/home.png"
import {useNavigate} from "react-router-dom";
import {config} from "../../config";

const PageMain: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const nav = useNavigate();

    useEffect(() => {
        dispatch(actionApp.clearAll())
    }, [])
    return (
        <PageMainContainer>
            <PageMainArticle onClick={() => nav(`${config.uiStart}/files`)}>
                    <img src={fileIcon} alt={"файлы"}/>
                    <PageMainText>Файлы</PageMainText>
            </PageMainArticle>
            <PageMainArticle onClick={() => nav(`${config.uiStart}/cameras`)}>
                <img src={cameraIcon} alt={"Камеры"}/>
                <PageMainText>Камеры</PageMainText>
            </PageMainArticle>
            <PageMainArticle onClick={() => nav(`${config.uiStart}/smart-home`)}>
                <img src={homeIcon} alt={"Дом"}/>
                <PageMainText>Дом</PageMainText>
            </PageMainArticle>
        </PageMainContainer>
    )
}

export default memo(PageMain)
